module.exports = __webpack_public_path__ + "img/about-people.7584cc45.png";